import styled, { css } from 'styled-components'

interface iBoxProps{
  margin?: string
}

export const Container = styled.div<iBoxProps>`

${props => props.margin && css<iBoxProps>`
    margin: ${props => props.margin};`
}

background: var(--c1);
display: flex;
position: relative;
flex-direction: column;
padding: 1rem;
position: relative;
border-radius: 1.25rem;
box-shadow: var(--SombraBackground);
`
